import { Plus, Pencil, Trash2, Loader } from "lucide-react";
import { forwardRef } from "react";


// export const AddButton = ({ show, onClick, formMode, setFormMode }) => {
//   return (
//     <button
//       onClick={() => {
//         onClick();
//         setFormMode("add");
//       }}
//       disabled={formMode === "add"}
//       className={`h-7 w-7 flex justify-center items-center rounded-full ${
//         !show && "hidden"
//       } ${formMode === "add" && "shadow-md shadow-[var(--common-add-btn-shadow)]"} bg-[var(--common-add-btn-bg)] text-[var( --common-add-btn-text)] hover:bg-[var(--common-add-btn-hover-bg)]`}
//     >
//       <Plus
//         size={18}
//         strokeWidth={3}
//         className="text-[var(--common-add-btn-text)] transition-all duration-100 ease-in-out"
//       />
//     </button>
//   );
// };
// export const EditButton = ({ show, onClick, formMode, setFormMode }) => {
//   return (
//     <button
//       onClick={() => {
//         onClick();
//         setFormMode("edit");
//       }}
//       disabled={formMode === "edit"}
//       className={`h-7 w-7 flex justify-center items-center rounded-full ${
//         !show && "hidden"
//       } ${formMode === "edit" && "shadow-md shadow-[var(--common-edit-btn-shadow)]"} bg-[var(--common-edit-btn-bg)] text-[var(--common-edit-btn-text)] hover:bg-[var(--common-edit-btn-hover-bg)]`}
//     >
//       <Pencil
//         size={16}
//         className="stroke-2 text-[var(--common-edit-btn-text)] transition-all duration-100 ease-in-out"
//       />
//     </button>
//   );
// };
// export const DeleteButton = ({ show, onClick, formMode }) => {
//   return (
//     <button
//       onClick={onClick}
//       disabled={formMode === "add"}
//       className={`h-7 w-7 flex justify-center items-center rounded-full ${
//         !show && "hidden"
//       } ${
//         formMode === "add"
//           ? "bg-gray-400 text-black"
//           : "bg-[var(--common-delete-btn-bg)] hover:bg-[var(--common-delete-btn-hover-bg)] text-[var(--common-delete-btn-text)]"
//       }`}
//     >
//       <Trash2
//         size={18}
//         className="stroke-2 transition-all duration-100 ease-in-out"
//       />
//     </button>
//   );
// };
// export const SaveButton = forwardRef(({ show, onClick }, ref) => {
//   return (
//       <button
//         onClick={onClick}
//         ref={ref}
//         className={`${ButtonStyles} ${
//           !show && "hidden"
//         } text-[14px] font-semibold w-[5rem] h-7 bg-[var(--common-save-btn-bg)] text-[var(--common-save-btn-text)] hover:bg-[var(--common-save-btn-hover-bg)] squircle-a-8`}
//       >
//         Save
//       </button>
//   );
// });
// export const CancelButton = ({ show, onClick }) => {
//   return (
//       <button
//         onClick={onClick}
//         className={`${ButtonStyles} ${
//           !show && "hidden"
//         } text-[14px] font-semibold w-[5rem] h-7 bg-[var(--common-cancel-btn-bg)] text-[var(--common-cancel-btn-text)] hover:bg-[var(--common-cancel-btn-hover-bg)] squircle-a-8`}
//       >
//         Cancel
//       </button>
//   );
// };

export const ActionButton = ({text,onClick,isLoading=false,customStyle=''}) => {
  return (
    <button
      onClick={isLoading? ()=>{}:onClick}
      className={`bg-white outline-none text-[14px] rounded-lg font-semibold text-black px-4 py-1 hover:bg-white/80 flex justify-center ${isLoading ?"cursor-progress":"cursor-pointer"} items-center ${customStyle}`}
    >
      {isLoading ?<Loader className="animate-spin"/> :text}
    </button>
  );
};
